// extracted by mini-css-extract-plugin
export var chip = "_cu-0";
export var filterDropdown = "_cu-5";
export var filterItem = "_cu-6";
export var icon = "_cu-1";
export var removeButton = "_cu-3";
export var removeIcon = "_cu-4";
export var separator = "_cu-2";